import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";
import { FolderPlus, Check, FolderOpen } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export default function AddToCollection({ api, paperId }) {
  const [collections, setCollections] = useState([]);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await axios.get(`${api}/collections`, { withCredentials: true });
        setCollections(res.data);
      } catch {
        // ignore
      }
    };
    fetch();
  }, [api]);

  const handleAdd = async (colId, colName) => {
    try {
      const res = await axios.post(`${api}/collections/${colId}/papers`, { paper_id: paperId }, { withCredentials: true });
      if (res.data.status === "already_in_collection") {
        toast.info(`Already in "${colName}"`);
      } else {
        toast.success(`Added to "${colName}"`);
      }
    } catch {
      toast.error("Failed to add to collection");
    }
  };

  if (collections.length === 0) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="neo-btn bg-white dark:bg-[#2A2A2A] dark:border-[#444] dark:text-white p-2" data-testid="add-to-collection-btn">
          <FolderPlus className="w-4 h-4" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="border-2 border-neo-border dark:border-[#444] shadow-[3px_3px_0px_0px_#1A1A1A] dark:shadow-[3px_3px_0px_0px_#444] dark:bg-[#1E1E1E]" align="end">
        {collections.map((col) => (
          <DropdownMenuItem
            key={col.id}
            onClick={() => handleAdd(col.id, col.name)}
            className="cursor-pointer dark:text-white"
            data-testid={`add-to-${col.id}`}
          >
            <div className="w-3 h-3 rounded-full mr-2 border border-neo-border" style={{ backgroundColor: col.color }}></div>
            {col.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
